import { Route, Switch } from "react-router-dom";
import SideBar from "./components/sidebar";
import NavBar from "./components/navbar";
import useCustomState from "./hooks/State";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import CounterTypes from "./pages/CounterTypes";
import UserManagement from "./pages/UserManagement";
import ProjectDetails from "./pages/ProjectDetails";
import ProjectUserDetails from "./pages/ProjectUserDetails";

import { useEffect } from "react";
import { getUserInfo } from "./utils/UserInfo";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  SetUserInfo,
  SetStatistics,
  SetProjects,
  UpdateProjectsList,
  SetCounters,
  UpdateCountersList,
  SetProjectsByCities,
  SetTypesInfo,
  SetAdminProfile,
  SetCounterTypes,
  UpdateCounterTypes,
  SetCounterCategories,
} from "./store/actions";
import Counters from "./pages/Counters";
import { useMountAPI } from "./hooks/APICall";
import Call from "./service/API";
import ProjectUserCategoryDetails from "./pages/ProjectUserCategoryDetails";
import ProjectUserCounterDetails from "./pages/ProjectUserCounter";
import { useSelector } from "react-redux";
import CounterInfo from "./pages/CounterInfo";
import CounterTypeInfo from "./pages/CounterTypeInfo";
import UserDetails from "./pages/UserDetails";
import Profile from "./pages/Profile";
import Modules from "./pages/Modules";
import Redirect from "./pages/Redirect";
import Tags from "./pages/Tags";
import Reports from "./pages/Reports";
import ConsumptionReports from "./pages/ConsumptionReports";
import CounterReports from "./pages/CounterReports";
import CounterTypeReports from "./pages/CounterTypeReports";
import ProjectReports from "./pages/ProjectReports";
import Loading from "./components/loading";
import AccessabilityManagement from "./pages/AccessabilityManagement";
import AddAdmin from "./pages/AddAdmin";
import AdminInfo from "./pages/adminInfo";
import EditAdmin from "./pages/EditAdmin";
import HowToCalculateBill from "./pages/HowToCalculateBill";
import Bills from "./pages/Bills";
import BillInfo from "./pages/BillInfo";
import ProjectSettings from "./pages/ProjectSettings";
import ProjectsList from "./pages/ProjectsList";
import ProjectAdd from "./pages/ProjectAdd";
import ShowBill from "./pages/ShowBill";
import CreateBill from "./pages/CreateBill";
import BillView from "./pages/BillView";
import EventsView from "./pages/EventsView";
import LiveDeviceView from "./pages/LiveDeviceView";
import OrdersView from "./pages/OrdersView";
import ProjectDashboardView from "./pages/ProjectDashboardView";

const AdminRoutes = () => {
  const sidebarCollapse = useCustomState(false);
  const sidebarToggled = useCustomState(false);

  const Collapse = () => {
    if (window.innerWidth > 990) {
      sidebarCollapse.handleChange(!sidebarCollapse.value);
    } else {
      sidebarToggled.handleChange(!sidebarToggled.value);
    }
  };

  const Toggle = () => {
    sidebarToggled.handleChange(!sidebarToggled.value);
  };

  const projectsIsLoading = useCustomState(true);
  const countersIsLoading = useCustomState(true);
  const projectsByCityIsLoading = useCustomState(true);
  const typesInfoIsLoading = useCustomState(true);
  const adminProfileIsLoading = useCustomState(true);
  const counterTypesIsLoading = useCustomState(true);
  const categoriesIsLoading = useCustomState(true);

  const history = useHistory();
  const dispatch = useDispatch();

  const windowHeight = window.innerHeight;

  const statisticsUtils = {
    type: null,
    project: null,
    activation: null,
    validation: null,
    dispatch: dispatch,
  };

  const projectsUtils = {
    page: 1,
    count: 200,
    projectNameFilter: "",
    projectCreateDateFilter: "",
    isLoading: projectsIsLoading,
    dispatch: dispatch,
  };

  const counterUtils = {
    page: 1,
    count: 1000,
    isLoading: countersIsLoading,
    dispatch: dispatch,
    history: history,
  };

  const projectsByCityUtils = {
    dispatch: dispatch,
    isLoading: projectsByCityIsLoading,
  };

  const typesInfoUtils = {
    dispatch: dispatch,
    isLoading: typesInfoIsLoading,
  };

  const adminProfileUtils = {
    dispatch: dispatch,
    isLoading: adminProfileIsLoading,
  };

  const counterTypesUtils = {
    page: 1,
    count: 1000,
    typeName: "",
    typeDate: "",
    isLoading: counterTypesIsLoading,
    dispatch: dispatch,
    history: history,
  };

  const categoriesUtils = {
    page: 1,
    count: 1000,
    name: "",
    date: "",
    isLoading: categoriesIsLoading,
    history: history,
    dispatch: dispatch,
  };

  useMountAPI(fetchStatistics, statisticsUtils);
  useMountAPI(fetchprojectsList, projectsUtils);
  useMountAPI(fetchCounters, counterUtils);
  useMountAPI(fetchProjectsByCity, projectsByCityUtils);
  useMountAPI(fetchTypesInfo, typesInfoUtils);
  useMountAPI(fetchAdminInfo, adminProfileUtils);
  useMountAPI(fetchCounterTypes, counterTypesUtils);
  useMountAPI(fetchCategories, categoriesUtils);

  useEffect(() => {
    const userInfo = getUserInfo();
    if (userInfo) {
      if (userInfo.token) {
        dispatch(SetUserInfo(userInfo));
      }
    } else {
      history.push("/admin/login");
    }
  }, []);

  const updateCommands = useSelector((state) => state.updateCommands);

  useEffect(() => {
    fetchprojectsList(projectsUtils);
  }, [updateCommands.updateProjectsList]);

  useEffect(() => {
    fetchAdminInfo(adminProfileUtils);
  }, [updateCommands.updateProfile]);

  if (
    !projectsIsLoading.value &&
    !countersIsLoading.value &&
    !projectsByCityIsLoading.value &&
    !typesInfoIsLoading.value &&
    !adminProfileIsLoading.value &&
    !counterTypesIsLoading.value &&
    !categoriesIsLoading.value
  ) {
    return (
      <div
        style={{
          margin: "0",
          padding: "0",
          display: "flex",
          position: "relative",
          height: "calc(100vh)",
          direction: "rtl",
          textAlign: "right",
        }}
      >
        <SideBar
          userInfo={{}}
          collapse={sidebarCollapse.value}
          onToggle={Toggle}
          toggled={sidebarToggled.value}
        />
        <div
          id="main"
          style={{
            paddingTop: "110px",
            paddingRight: "0",
            paddingBottom: "0",
            paddingLeft: "0",
            flexGrow: "1",
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          <NavBar sideBarCollapse={Collapse} />
          <Switch>
            <Route
              path={"/admin"}
              exact
              render={(props) => <Home {...props} />}
            />
            <Route
              path={"/admin/projects"}
              exact
              render={(props) => <ProjectsList {...props} />}
            />
            <Route
              path={"/admin/add-project"}
              exact
              render={(props) => <ProjectAdd {...props} />}
            />
            <Route
              path={"/admin/show-bills"}
              exact
              render={(props) => <ShowBill {...props} />}
            />
            <Route
              path={"/admin/create-bills"}
              exact
              render={(props) => <CreateBill {...props} />}
            />
            <Route
              path={"/admin/counter-types"}
              exact
              render={(props) => <CounterTypes {...props} />}
            />
            <Route
              path={"/admin/users-management"}
              exact
              render={(props) => <UserManagement {...props} />}
            />
            {/* <Route
              path={"/admin/project-dash/:pId"}
              exact
              render={(props) => <ProjectDetails {...props} />}
            /> */}
            <Route
              path={"/admin/project-dash/:pId"}
              exact
              render={(props) => <ProjectDashboardView {...props} />}
            />
            <Route
              path={"/admin/project-dash/:pId/users/:userId"}
              exact
              render={(props) => <ProjectUserDetails {...props} />}
            />
            <Route
              path={"/admin/counters"}
              exact
              render={(props) => <Counters {...props} />}
            />
            <Route
              path={"/admin/live-devices/:deviceSerial"}
              exact
              render={(props) => <LiveDeviceView {...props} />}
            />
            <Route
              path={
                "/admin/project-dash/:pId/users/:userId/counter-category/:categoryId"
              }
              exact
              render={(props) => <ProjectUserCategoryDetails {...props} />}
            />
            <Route
              path={
                "/admin/project-dash/:pId/users/:userId/counter-category/:categoryId/counter/:counterSerial"
              }
              exact
              render={(props) => <ProjectUserCounterDetails {...props} />}
            />
            <Route
              path={"/admin/project-dash/:pId/counters/:counterSerial"}
              exact
              render={(props) => <CounterInfo {...props} />}
            />
            <Route
              path={"/admin/counter/:counterSerial"}
              exact
              render={(props) => <CounterInfo {...props} />}
            />
            <Route
              path={"/admin/counter/:counterSerial/how-to-calculate-bill"}
              exact
              render={(props) => <HowToCalculateBill {...props} />}
            />
            <Route
              path={"/admin/counter/:counterSerial/bills"}
              exact
              render={(props) => <Bills {...props} />}
            />
            <Route
              path={"/admin/counter/:counterSerial/bills/:billId"}
              exact
              render={(props) => <BillInfo {...props} />}
            />
            <Route
              path={"/admin/show-bills/:billId"}
              exact
              render={(props) => <BillView {...props} />}
            />
            <Route
              path={"/admin/events"}
              exact
              render={(props) => <EventsView {...props} />}
            />
            <Route
              path={"/admin/orders"}
              exact
              render={(props) => <OrdersView {...props} />}
            />
            <Route
              path={"/admin/counter-types/:counterType"}
              exact
              render={(props) => <CounterTypeInfo {...props} />}
            />
            <Route
              path={"/admin/users/:userId"}
              exact
              render={(props) => <UserDetails {...props} />}
            />
            <Route
              path={"/admin/project-dash/:pId/counter-types/:counterType"}
              exact
              render={(props) => <CounterTypeInfo {...props} />}
            />
            <Route
              path={"/admin/profile"}
              exact
              render={(props) => <Profile {...props} />}
            />
            <Route
              path={"/admin/modules"}
              exact
              render={(props) => <Modules {...props} />}
            />
            <Route
              path={"/admin/counter-tags"}
              exact
              render={(props) => <Tags {...props} />}
            />
            <Route
              path={"/admin/reports"}
              exact
              render={(props) => <Reports {...props} />}
            />
            <Route
              path={"/admin/reports/projects"}
              exact
              render={(props) => <ProjectReports {...props} />}
            />
            <Route
              path={"/admin/reports/counter-types"}
              exact
              render={(props) => <CounterTypeReports {...props} />}
            />
            <Route
              path={"/admin/reports/counters"}
              exact
              render={(props) => <CounterReports {...props} />}
            />
            <Route
              path={"/admin/reports/consumptions"}
              exact
              render={(props) => <ConsumptionReports {...props} />}
            />
            <Route
              path={"/admin/accessability"}
              exact
              render={(props) => <AccessabilityManagement {...props} />}
            />
            <Route
              path={"/admin/accessability/add-admin"}
              exact
              render={(props) => <AddAdmin {...props} />}
            />
            <Route
              path={"/admin/accessability/admin-info/:adminId"}
              exact
              render={(props) => <AdminInfo {...props} />}
            />
            <Route
              path={"/admin/accessability/edit-admin/:adminId"}
              exact
              render={(props) => <EditAdmin {...props} />}
            />
            <Route
              path={"/admin/project-dash/:projectId/settings"}
              exact
              render={(props) => <ProjectSettings {...props} />}
            />
            <Route path={"/"} render={(props) => <Redirect {...props} />} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </div>
    );
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: windowHeight + "px",
          position: "relative",
        }}
      >
        <Loading />
      </div>
    );
  }
};

export default AdminRoutes;

const processStatistics = (statistics) => {
  const data = {
    users: statistics.all_users,
    projects: statistics.water_meter_project,
    counters: statistics.all_water_meter,
    counterTypes: statistics.water_meter_type,
    validCounters: statistics.water_meter_validation,
    selledCounters: statistics.water_meter_activation,
    totalConsumption: statistics.sum_all_consumption_value,
    // totalRecords: statistics.all_consumption_records,
  };
  return data;
};

const fetchStatistics = (utils) => {
  const type = utils.type;
  const project = utils.project;
  const activation = utils.activation;
  const validation = utils.validation;
  const dispatch = utils.dispatch;

  const data = {
    type: type,
    project: project,
    water_meter_activation: activation,
    water_meter_validation: validation,
  };

  Call("POST", "watermeters/admin/countAll", data)
    .then((response) => {
      // console.log("statistics: ", response.data.data);
      if (response.data.code == 200) {
        dispatch(SetStatistics(processStatistics(response.data.data)));
      }
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
    });
};

// ------------------------------------------------------------------------------------------------------------
// fetch projects

const fetchprojectsList = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const projectNameFilter = utils.projectNameFilter;
  const projectCreateDateFilter = utils.projectCreateDateFilter;
  const isLoading = utils.isLoading;
  const dispatch = utils.dispatch;

  const data = {
    page: page,
    count: count,
    water_meter_project_name: projectNameFilter,
    water_meter_project_create_date: projectCreateDateFilter,
  };
  Call("POST", "WaterMeterProjectsURL/admin/getAll", data)
    .then((response) => {
      // console.log("projects", response);
      if (response.data.code == 200) {
        const ps = response.data.data;
        dispatch(SetProjects(ps));
        dispatch(UpdateProjectsList({ updateProjectsList: false }));
        isLoading.handleChange(false);
      }
    })
    .catch((error) => {
      // console.log(error);
      isLoading.handleChange(false);
    });
};

//----------------------------------------------------------------------------------------------------------------------
// fetch counters
const fetchCounters = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const isLoading = utils.isLoading;
  const dispatch = utils.dispatch;
  const history = utils.history;

  const data = {
    page: page,
    count: count,
  };

  Call("POST", "watermeters/admin/getAll", data)
    // Call("POST", "watermeters/v2/admin/getAll", data)
    .then((response) => {
      // console.log("counters", response.data.data);
      if (response.data.code == 200) {
        // console.log(response.data.data);
        const cs = response.data.data;
        // dispatch(SetCounters(cs.slice(0, cs.length - 1)));
        dispatch(SetCounters(cs));
        dispatch(UpdateCountersList({ updateCountersList: false }));
      }
      // console.log(response);
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code == 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};

// -------------------------------------------------------------------------------------------------------

const fetchProjectsByCity = (utils) => {
  const dispatch = utils.dispatch;
  const isLoading = utils.isLoading;

  Call("GET", "WaterMeterProjectsURL/admin/getAll/city/count", null)
    .then((response) => {
      // console.log("projects by cities: ", response);
      if (response.data.code == 200) {
        dispatch(SetProjectsByCities(response.data.data));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.respone) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};

// ---------------------------------------------------------------------------------------------------

const fetchTypesInfo = (utils) => {
  const dispatch = utils.dispatch;
  const isLoading = utils.isLoading;

  Call("GET", "WaterMeterTypes/admin/getAllValues", null)
    .then((response) => {
      // console.log("typesInfo: ", response);
      if (response.data.code == 200) {
        dispatch(SetTypesInfo(response.data.data));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};

// ----------------------------------------------------------------------------------------------------------

const fetchAdminInfo = (utils) => {
  const dispatch = utils.dispatch;
  const isLoading = utils.isLoading;

  Call("POST", "admins/admin/getProfile", null)
    .then((response) => {
      // console.log("Admin profile: ", response);
      if (response.data.code == 200) {
        dispatch(SetAdminProfile(response.data.data));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};

// -------------------------------------------------------------------------------------------------------------------

const fetchCounterTypes = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const typeName = utils.typeName;
  const typeDate = utils.typeDate;
  const isLoading = utils.isLoading;
  const dispatch = utils.dispatch;
  const history = utils.history;

  const data = {
    page: page,
    count: count,
    water_meter_type_name: typeName,
    water_meter_type_create_date: typeDate,
  };

  Call("POST", "WaterMeterTypes/admin/getAll", data)
    .then((response) => {
      if (response.data.code == 200) {
        dispatch(SetCounterTypes(response.data.data));
        dispatch(UpdateCounterTypes({ updateCounterTypes: false }));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code == 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};

const processCategories = (categories) => {
  const results = [];
  categories.map((cat, idx) => {
    let units;
    if (cat.water_meter_tag_name.includes("آب")) {
      units = ["لیتر", "مترمکعب"];
    } else if (cat.water_meter_tag_name.includes("برق")) {
      units = ["وات ساعت", "کیلو وات ساعت"];
    } else if (cat.water_meter_tag_name.includes("گاز")) {
      units = ["مترمکعب"];
    } else {
      units = [""];
    }
    const data = {
      registeredAt: cat.water_meter_tag_create_date,
      files: cat.water_meter_tag_files,
      id: cat.water_meter_tag_id,
      name: cat.water_meter_tag_name,
      info: cat.water_meter_tag_other_information,
      units: units,
      selectedUnitIdx: 0,
    };
    results.push(data);
  });
  return results;
};

const fetchCategories = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const filteredName = utils.name;
  const filteredDate = utils.date;
  const isLoading = utils.isLoading;
  const history = utils.history;
  const dispatch = utils.dispatch;

  const data = {
    page: page,
    count: count,
    water_meter_tag_name: filteredName,
    water_meter_type_create_date: filteredDate,
  };

  Call("POST", "WaterMeterTags/admin/getAll", data)
    .then((response) => {
      // console.log("categories: ", response);
      if (response.data.code === 200) {
        dispatch(SetCounterCategories(processCategories(response.data.data)));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code === 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};
